import React from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { isPlatformAdminRole } from "@/utils/accessControl";
import { getDefaultAuthorizedRoute } from "@/utils/defaultAuthorizedRoute";

interface SuperAdminGuardProps {
  children: React.ReactNode;
}

export const SuperAdminGuard: React.FC<SuperAdminGuardProps> = ({
  children,
}) => {
  const { t } = useTranslation();
  const { userProfile, isLoading } = useAuthenticatedUser();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-muted-foreground">{t("common.loading")}</div>
      </div>
    );
  }

  if (!isPlatformAdminRole(userProfile)) {
    return <Navigate replace to={getDefaultAuthorizedRoute(userProfile)} />;
  }

  return <>{children}</>;
};
